module.exports = __webpack_public_path__ + "static/media/emj02.c575bc3a.svg";